// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import styles from '../StudyManagement.module.css';
// import { ENROLLMENT_STATUSES } from '../Contants';
// import { convertDateFormat } from '../utils';
// // import { ENROLLMENT_STATUSES } from '../constants';
// // import { convertDateFormat } from '../utils/helpers';

// const SubjectDrawer = ({
//     isOpen,
//     onClose,
//     mode,
//     initialData,
//     sites,
//     loadingSites,
//     userAssignedSiteId,
//     onSubmit,
//     onCreateAndCapture,
//     generateSubjectId,
//     checkSiteLimit
// }) => {
//     const navigate = useNavigate();
//     const [formData, setFormData] = useState({
//         siteName: '',
//         siteId: null,
//         subjectId: '',
//         subjectInitials: '',
//         enrollmentDate: '',
//         enrollmentStatus: 'screening'
//     });

//     useEffect(() => {
//         if (isOpen && mode === 'create' && userAssignedSiteId) {
//             const assignedSite = sites.find(s => s.id === userAssignedSiteId);
//             if (assignedSite) {
//                 setFormData({
//                     siteName: `${assignedSite.code} - ${assignedSite.name}`,
//                     siteId: userAssignedSiteId,
//                     subjectId: generateSubjectId(assignedSite.code),
//                     subjectInitials: '',
//                     enrollmentDate: '',
//                     enrollmentStatus: 'screening'
//                 });
//             }
//         } else if (isOpen && (mode === 'edit' || mode === 'view') && initialData) {
//             setFormData({
//                 siteName: initialData.siteName,
//                 siteId: initialData.siteId,
//                 subjectId: initialData.subjectId,
//                 subjectInitials: initialData.subjectInitials,
//                 enrollmentDate: convertDateFormat(initialData.dateOfEnrollment),
//                 enrollmentStatus: initialData.enrollmentStatus.toLowerCase()
//             });
//         }
//     }, [isOpen, mode, initialData, userAssignedSiteId, sites]);

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prev => ({ ...prev, [name]: value }));
//     };

//     const handleSubmit = () => {
//         if (!formData.siteId || !formData.subjectId || !formData.subjectInitials || !formData.enrollmentDate) {
//             alert('Please fill in all required fields');
//             return;
//         }
//         if (!checkSiteLimit(formData.siteId)) {
//             const site = sites.find(s => s.id === formData.siteId);
//             alert(`Enrollment limit reached for this site. Maximum ${site.maxEnrollment} subjects allowed.`);
//             return;
//         }
//         onSubmit(formData);
//         onClose();
//     };

//     const handleCreateAndCapture = () => {
//         if (!formData.siteId || !formData.subjectId || !formData.subjectInitials || !formData.enrollmentDate) {
//             alert('Please fill in all required fields');
//             return;
//         }
//         if (!checkSiteLimit(formData.siteId)) {
//             const site = sites.find(s => s.id === formData.siteId);
//             alert(`Enrollment limit reached for this site. Maximum ${site.maxEnrollment} subjects allowed.`);
//             return;
//         }
//         onCreateAndCapture(formData);
//         navigate('/survey/1');
//     };

//     const selectedSite = sites.find(site => site.id === formData.siteId);
//     const isFormDisabled = mode === 'view';

//     const getDrawerTitle = () => {
//         if (mode === 'create') return 'Create New Subject';
//         if (mode === 'edit') return 'Edit Subject';
//         if (mode === 'view') return 'View Subject';
//         return 'Subject Details';
//     };

//     if (!isOpen) return null;

//     return (
//         <>
//             <div className={styles.backdrop} onClick={onClose}></div>
//             <div className={styles.drawer}>
//                 <div className={styles.drawerHeader}>
//                     <h2 className={styles.drawerTitle}>{getDrawerTitle()}</h2>
//                     <button className={styles.closeButton} onClick={onClose}>✕</button>
//                 </div>

//                 <div className={styles.drawerContent}>
//                     <form className={styles.form}>
//                         <div className={styles.formGroup}>
//                             <label className={styles.label}>
//                                 Site Name <span className={styles.required}>*</span>
//                             </label>
//                             {loadingSites ? (
//                                 <div className={styles.loadingText}>Loading sites...</div>
//                             ) : (
//                                 <>
//                                     <select
//                                         className={styles.input}
//                                         name="siteId"
//                                         value={formData.siteId || ''}
//                                         onChange={handleInputChange}
//                                         disabled={isFormDisabled || (mode === 'create' && userAssignedSiteId !== null)}
//                                     >
//                                         {mode === 'create' ? (
//                                             userAssignedSiteId ? (
//                                                 sites.filter(site => site.id === userAssignedSiteId).map(site => (
//                                                     <option key={site.id} value={site.id}>
//                                                         {site.code} - {site.name} ({site.enrolled}/{site.maxEnrollment})
//                                                     </option>
//                                                 ))
//                                             ) : (
//                                                 <>
//                                                     <option value="">Select a site</option>
//                                                     {sites.map(site => (
//                                                         <option key={site.id} value={site.id} disabled={site.enrolled >= site.maxEnrollment}>
//                                                             {site.code} - {site.name} ({site.enrolled}/{site.maxEnrollment})
//                                                         </option>
//                                                     ))}
//                                                 </>
//                                             )
//                                         ) : (
//                                             <option value={formData.siteId}>{formData.siteName}</option>
//                                         )}
//                                     </select>
//                                     {mode === 'create' && userAssignedSiteId && (
//                                         <div className={styles.siteRestrictionInfo}>
//                                             <span className={styles.infoIcon}>ℹ️</span>
//                                             <span className={styles.infoText}>You can only create subjects for your assigned site</span>
//                                         </div>
//                                     )}
//                                 </>
//                             )}
//                         </div>

//                         <div className={styles.formGroup}>
//                             <label className={styles.label}>
//                                 Subject ID <span className={styles.required}>*</span>
//                             </label>
//                             <input
//                                 type="text"
//                                 className={styles.input}
//                                 name="subjectId"
//                                 value={formData.subjectId}
//                                 placeholder="Auto-generated"
//                                 disabled
//                                 readOnly
//                             />
//                         </div>

//                         <div className={styles.formGroup}>
//                             <label className={styles.label}>
//                                 Subject Initials <span className={styles.required}>*</span>
//                             </label>
//                             <input
//                                 type="text"
//                                 className={styles.input}
//                                 name="subjectInitials"
//                                 value={formData.subjectInitials}
//                                 onChange={handleInputChange}
//                                 placeholder="E.G., JD"
//                                 disabled={isFormDisabled}
//                             />
//                         </div>

//                         <div className={styles.formGroup}>
//                             <label className={styles.label}>
//                                 Enrollment Date <span className={styles.required}>*</span>
//                             </label>
//                             <input
//                                 type="date"
//                                 className={styles.input}
//                                 name="enrollmentDate"
//                                 value={formData.enrollmentDate}
//                                 onChange={handleInputChange}
//                                 disabled={isFormDisabled}
//                             />
//                         </div>

//                         <div className={styles.formGroup}>
//                             <label className={styles.label}>
//                                 Enrollment Status <span className={styles.required}>*</span>
//                             </label>
//                             <select
//                                 className={styles.input}
//                                 name="enrollmentStatus"
//                                 value={formData.enrollmentStatus}
//                                 onChange={handleInputChange}
//                                 disabled={isFormDisabled}
//                             >
//                                 {ENROLLMENT_STATUSES.map(status => (
//                                     <option key={status.value} value={status.value}>{status.label}</option>
//                                 ))}
//                             </select>
//                         </div>

//                         {formData.siteId && selectedSite && (
//                             <div className={styles.formGroup}>
//                                 <label className={styles.label}>Site Enrollment Status</label>
//                                 <div className={styles.statusInfo}>
//                                     <span className={styles.statusIcon}>✓</span>
//                                     <div>
//                                         <p className={styles.statusTitle}>Enrollment Status</p>
//                                         <p className={styles.statusSubtitle}>{selectedSite.code} - {selectedSite.name}</p>
//                                         <p className={styles.statusDetail}>
//                                             {selectedSite.enrolled} of {selectedSite.maxEnrollment} subjects enrolled
//                                         </p>
//                                         <div className={styles.progressBar}>
//                                             <div className={styles.progressFill} style={{ width: `${selectedSite.progress}%` }}></div>
//                                         </div>
//                                         <p className={styles.statusText}>
//                                             {selectedSite.enrolled < selectedSite.maxEnrollment ? (
//                                                 <span className={styles.greenText}>
//                                                     ✓ {selectedSite.maxEnrollment - selectedSite.enrolled} enrollment slot{selectedSite.maxEnrollment - selectedSite.enrolled !== 1 ? 's' : ''} remaining
//                                                 </span>
//                                             ) : (
//                                                 <span className={styles.redText}>✕ Enrollment limit reached</span>
//                                             )}
//                                         </p>
//                                     </div>
//                                 </div>
//                             </div>
//                         )}
//                     </form>
//                 </div>

//                 <div className={styles.drawerFooter}>
//                     {mode === 'view' ? (
//                         <button className={styles.cancelButton} onClick={onClose}>Close</button>
//                     ) : mode === 'edit' ? (
//                         <>
//                             <button className={styles.cancelButton} onClick={onClose}>Cancel</button>
//                             <button className={styles.primaryButton} onClick={handleSubmit}>Save Changes</button>
//                         </>
//                     ) : (
//                         <>
//                             <button className={styles.cancelButton} onClick={onClose}>Cancel</button>
//                             <button className={styles.enrollButton} onClick={handleSubmit}>Enroll New Subject</button>
//                             <button className={styles.primaryButton} onClick={handleCreateAndCapture}>Create and Start Capture</button>
//                         </>
//                     )}
//                 </div>
//             </div>
//         </>
//     );
// };

// export default SubjectDrawer;

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import styles from '../StudyManagement.module.css';
// import { ENROLLMENT_STATUSES } from '../Contants';
// import { convertDateFormat } from '../utils';

// const SubjectDrawer = ({
//     isOpen,
//     onClose,
//     mode,
//     initialData,
//     sites,
//     loadingSites,
//     userAssignedSiteId,
//     onSubmit,
//     onCreateAndCapture,
//     generateSubjectId,
//     checkSiteLimit
// }) => {
//     const navigate = useNavigate();
//     const [isSubmitting, setIsSubmitting] = useState(false);

//     const [formData, setFormData] = useState({
//         siteName: '',
//         siteId: '',
//         subjectId: '',
//         subjectInitials: '',
//         enrollmentDate: '',
//         enrollmentStatus: 'screening'
//     });

//     useEffect(() => {
//         if (!isOpen) {
//             setFormData({
//                 siteName: '',
//                 siteId: '',
//                 subjectId: '',
//                 subjectInitials: '',
//                 enrollmentDate: '',
//                 enrollmentStatus: 'screening'
//             });
//             return;
//         }

//         if (mode === 'create' && userAssignedSiteId) {
//             const assignedSite = sites.find(s => s.id === Number(userAssignedSiteId));
//             if (assignedSite) {
//                 setFormData({
//                     siteName: `${assignedSite.code} - ${assignedSite.name}`,
//                     siteId: assignedSite.id,
//                     subjectId: generateSubjectId(assignedSite.code),
//                     subjectInitials: '',
//                     enrollmentDate: '',
//                     enrollmentStatus: 'screening'
//                 });
//             }
//         } else if ((mode === 'edit' || mode === 'view') && initialData) {
//             setFormData({
//                 siteName: initialData.siteName,
//                 siteId: initialData.siteId,
//                 subjectId: initialData.subjectId,
//                 subjectInitials: initialData.subjectInitials,
//                 enrollmentDate: convertDateFormat(initialData.dateOfEnrollment),
//                 enrollmentStatus: initialData.enrollmentStatus.toLowerCase()
//             });
//         }

//     }, [isOpen, mode, initialData, userAssignedSiteId, sites, generateSubjectId]);

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;

//         if (name === 'siteId') {
//             const site = sites.find(s => s.id === Number(value));
//             setFormData(prev => ({
//                 ...prev,
//                 siteId: value,
//                 siteName: `${site.code} - ${site.name}`,
//                 subjectId: generateSubjectId(site.code)
//             }));
//             return;
//         }

//         setFormData(prev => ({ ...prev, [name]: value }));
//     };

//     const validateForm = () => {
//         const requiredFields = ['siteId', 'subjectId', 'subjectInitials', 'enrollmentDate'];
//         for (let f of requiredFields) {
//             if (!formData[f]) {
//                 alert('Please fill in all required fields');
//                 return false;
//             }
//         }

//         if (!checkSiteLimit(formData.siteId)) {
//             const site = sites.find(s => s.id === Number(formData.siteId));
//             alert(`Enrollment limit reached for this site. Maximum ${site.maxEnrollment} subjects allowed.`);
//             return false;
//         }

//         return true;
//     };

//     const handleSubmit = async () => {
//         if (!validateForm()) return;
//         setIsSubmitting(true);
//         await onSubmit(formData);
//         setIsSubmitting(false);
//     };

//     const handleCreateAndCapture = async () => {
//         if (!validateForm()) return;
//         setIsSubmitting(true);
//         await onCreateAndCapture(formData);
//         setIsSubmitting(false);
//     };

//     const selectedSite = sites.find(s => s.id === Number(formData.siteId));
//     const isFormDisabled = mode === 'view';

//     const getDrawerTitle = () => {
//         if (mode === 'create') return 'Create New Subject';
//         if (mode === 'edit') return 'Edit Subject';
//         if (mode === 'view') return 'View Subject';
//         return 'Subject Details';
//     };

//     if (!isOpen) return null;

//     return (
//         <>
//             <div className={styles.backdrop} onClick={onClose}></div>

//             <div className={styles.drawer}>
//                 <div className={styles.drawerHeader}>
//                     <h2 className={styles.drawerTitle}>{getDrawerTitle()}</h2>
//                     <button className={styles.closeButton} onClick={onClose}>✕</button>
//                 </div>

//                 <div className={styles.drawerContent}>
//                     <form className={styles.form}>

//                         {/* <div className={styles.formGroup}>
//                             <label className={styles.label}>Site Name <span className={styles.required}>*</span></label>

//                             {loadingSites ? (
//                                 <div className={styles.loadingText}>Loading sites...</div>
//                             ) : (
//                                 <select
//                                     className={styles.input}
//                                     name="siteId"
//                                     value={formData.siteId}
//                                     onChange={handleInputChange}
//                                     disabled={isFormDisabled}
//                                 >
//                                     <option value="">Select a site</option>
//                                     {sites.map(site => (
//                                         <option
//                                             key={site.id}
//                                             value={site.id}
//                                             disabled={site.enrolled >= site.maxEnrollment}
//                                         >
//                                             {site.code} - {site.name} ({site.enrolled}/{site.maxEnrollment})
//                                         </option>
//                                     ))}
//                                 </select>
//                             )}
//                         </div> */}
//                         <div className={styles.formGroup}>
//                             <label className={styles.label}>Site Name <span className={styles.required}>*</span></label>

//                             {loadingSites ? (
//                                 <div className={styles.loadingText}>Loading sites...</div>
//                             ) : (
//                                 <input
//                                     className={styles.input}
//                                     name="siteName"
//                                     value={formData.siteName}
//                                     disabled
//                                     readOnly
//                                 />
//                             )}
//                         </div>
//                         <div className={styles.formGroup}>
//                             <label className={styles.label}>Subject ID <span className={styles.required}>*</span></label>
//                             <input
//                                 className={styles.input}
//                                 name="subjectId"
//                                 value={formData.subjectId}
//                                 disabled
//                                 readOnly
//                             />
//                         </div>

//                         <div className={styles.formGroup}>
//                             <label className={styles.label}>Subject Initials <span className={styles.required}>*</span></label>
//                             <input
//                                 className={styles.input}
//                                 name="subjectInitials"
//                                 value={formData.subjectInitials}
//                                 onChange={handleInputChange}
//                                 disabled={isFormDisabled}
//                                 placeholder="E.g., JD"
//                             />
//                         </div>

//                         <div className={styles.formGroup}>
//                             <label className={styles.label}>Enrollment Date <span className={styles.required}>*</span></label>
//                             <input
//                                 type="date"
//                                 className={styles.input}
//                                 name="enrollmentDate"
//                                 value={formData.enrollmentDate}
//                                 onChange={handleInputChange}
//                                 disabled={isFormDisabled}
//                             />
//                         </div>

//                         {/* <div className={styles.formGroup}>
//                             <label className={styles.label}>Enrollment Status <span className={styles.required}>*</span></label>
//                             <select
//                                 className={styles.input}
//                                 name="enrollmentStatus"
//                                 value={formData.enrollmentStatus}
//                                 onChange={handleInputChange}
//                                 disabled={isFormDisabled}
//                             >
//                                 {ENROLLMENT_STATUSES.map(status => (
//                                     <option key={status.value} value={status.value}>
//                                         {status.label}
//                                     </option>
//                                 ))}
//                             </select>
//                         </div> */}

//                         {selectedSite && (
//                             <div className={styles.formGroup}>
//                                 <label className={styles.label}>Site Enrollment Status</label>
//                                 <div className={styles.statusInfo}>
//                                     <div>
//                                         <p className={styles.statusTitle}>{selectedSite.code} - {selectedSite.name}</p>
//                                         <p className={styles.statusDetail}>
//                                             {selectedSite.enrolled} of {selectedSite.maxEnrollment} subjects enrolled
//                                         </p>
//                                         <div className={styles.progressBar}>
//                                             <div
//                                                 className={styles.progressFill}
//                                                 style={{ width: `${selectedSite.progress}%` }}
//                                             ></div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         )}

//                     </form>
//                 </div>

//                 <div className={styles.drawerFooter}>
//                     {mode === 'view' ? (
//                         <button className={styles.cancelButton} onClick={onClose}>Close</button>
//                     ) : mode === 'edit' ? (
//                         <>
//                             <button className={styles.cancelButton} onClick={onClose}>Cancel</button>
//                             <button className={styles.primaryButton} onClick={handleSubmit} disabled={isSubmitting}>
//                                 {isSubmitting ? 'Saving...' : 'Save Changes'}
//                             </button>
//                         </>
//                     ) : (
//                         <>
//                             <button className={styles.cancelButton} onClick={onClose}>Cancel</button>
//                             <button className={styles.enrollButton} onClick={handleSubmit} disabled={isSubmitting}>
//                                 {isSubmitting ? 'Creating...' : 'Enroll New Subject'}
//                             </button>
//                             <button className={styles.primaryButton} onClick={handleCreateAndCapture} disabled={isSubmitting}>
//                                 {isSubmitting ? 'Creating...' : 'Create & Start Capture'}
//                             </button>
//                         </>
//                     )}
//                 </div>
//             </div>
//         </>
//     );
// };

// export default SubjectDrawer;

import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from '../StudyManagement.module.css';
import { ENROLLMENT_STATUSES } from '../Contants';
import { convertDateFormat } from '../utils';

const SubjectDrawer = ({
  isOpen,
  onClose,
  mode,
  initialData,
  sites,
  loadingSites,
  userAssignedSiteId,
  onSubmit,
  onCreateAndCapture,
  generateSubjectId,
  checkSiteLimit,
}) => {

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    siteName: '',
    siteId: '',
    subjectId: '',
    subjectInitials: '',
    enrollmentDate: '',
    enrollmentStatus: 'screening',
    userId: null,
    studyId: null,
  });

  useEffect(() => {
    if (!isOpen) {
      setFormData({
        siteName: '',
        siteId: '',
        subjectId: '',
        subjectInitials: '',
        enrollmentDate: '',
        enrollmentStatus: 'screening',
        userId: null,
        studyId: null,
      });
      return;
    }

    const userDetails = JSON.parse(localStorage.getItem('user')) || {};
    const currentUserId = userDetails.userId;
    const currentStudyId = userDetails.study?.studyId || userDetails.studyId;

    console.log('📦 User from localStorage:', userDetails);
    console.log('📦 UserId:', currentUserId);
    console.log('📦 StudyId:', currentStudyId);

    if (mode === 'create' && userAssignedSiteId) {
      const assignedSite = sites.find(
        (s) => s.id === Number(userAssignedSiteId)
      );
      console.log('📦 Assigned Site:', assignedSite);
      console.log('📦 Assigned Site ID:', userAssignedSiteId);
      if (assignedSite) {
        setFormData({
          siteName: `${assignedSite.code} - ${assignedSite.name}`,
          siteId: assignedSite.id,
          subjectId: generateSubjectId(assignedSite.code),
          subjectInitials: '',
          enrollmentDate: '',
          enrollmentStatus: 'screening',
          userId: currentUserId,
          studyId: currentStudyId,
        });
      }
    } else if ((mode === 'edit' || mode === 'view') && initialData) {
      setFormData({
        siteName: initialData.siteName,
        siteId: initialData.siteId,
        subjectId: initialData.subjectId,
        subjectInitials: initialData.subjectInitials,
        enrollmentDate: convertDateFormat(initialData.dateOfEnrollment),
        enrollmentStatus: initialData.enrollmentStatus.toLowerCase(),
        userId: currentUserId,
        studyId: currentStudyId,
      });
    }
  }, [isOpen, mode, initialData, userAssignedSiteId, sites, generateSubjectId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === 'siteId') {
      const site = sites.find((s) => s.id === Number(value));
      setFormData((prev) => ({
        ...prev,
        siteId: value,
        siteName: `${site.code} - ${site.name}`,
        subjectId: generateSubjectId(site.code),
      }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    const requiredFields = [
      'siteId',
      'subjectId',
      'subjectInitials',
      'enrollmentDate',
    ];
    for (let f of requiredFields) {
      if (!formData[f]) {
        alert('Please fill in all required fields');
        return false;
      }
    }

    if (!formData.userId) {
      alert('User ID not found. Please login again.');
      return false;
    }

    if (!formData.studyId) {
      alert('Study ID not found. Please select a study.');
      return false;
    }

    if (!checkSiteLimit(formData.siteId)) {
      const site = sites.find((s) => s.id === Number(formData.siteId));
      alert(
        `Enrollment limit reached for this site. Maximum ${site.maxEnrollment} subjects allowed.`
      );
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    console.log('📤 Submitting form data:', formData);

    setIsSubmitting(true);
    await onSubmit(formData);
    setIsSubmitting(false);
  };

  const handleCreateAndCapture = async () => {
    if (!validateForm()) return;

    console.log('📤 Creating and capturing with data:', formData);

    setIsSubmitting(true);
    await onCreateAndCapture(formData);
    setIsSubmitting(false);
  };

  const selectedSite = sites.find((s) => s.id === Number(formData.siteId));
  const isFormDisabled = mode === 'view';

  const getDrawerTitle = () => {
    if (mode === 'create') return 'Create New Subject';
    if (mode === 'edit') return 'Edit Subject';
    if (mode === 'view') return 'View Subject';
    return 'Subject Details';
  };

  if (!isOpen) return null;

  return (
    <>
      <div className={styles.backdrop} onClick={onClose}></div>

      <div className={styles.drawer}>
        <div className={styles.drawerHeader}>
          <h2 className={styles.drawerTitle}>{getDrawerTitle()}</h2>
          <button className={styles.closeButton} onClick={onClose}>
            ✕
          </button>
        </div>

        <div className={styles.drawerContent}>
          <form className={styles.form}>
            <div className={styles.formGroup}>
              <label className={styles.label}>
                Site Name <span className={styles.required}>*</span>
              </label>

              {loadingSites ? (
                <div className={styles.loadingText}>Loading sites...</div>
              ) : (
                <input
                  className={styles.input}
                  name='siteName'
                  value={formData.siteName}
                  disabled
                  readOnly
                />
              )}
            </div>

            <div className={styles.formGroup}>
              <label className={styles.label}>
                Subject ID <span className={styles.required}>*</span>
              </label>
              <input
                className={styles.input}
                name='subjectId'
                value={formData.subjectId}
                disabled
                readOnly
              />
            </div>

            <div className={styles.formGroup}>
              <label className={styles.label}>
                Subject Initials <span className={styles.required}>*</span>
              </label>
              <input
                className={styles.input}
                name='subjectInitials'
                value={formData.subjectInitials}
                onChange={handleInputChange}
                disabled={isFormDisabled}
                placeholder='E.g., JD'
              />
            </div>

            <div className={styles.formGroup}>
              <label className={styles.label}>
                Enrollment Date <span className={styles.required}>*</span>
              </label>
              <input
                type='date'
                className={styles.input}
                name='enrollmentDate'
                value={formData.enrollmentDate}
                onChange={handleInputChange}
                disabled={isFormDisabled}
              />
            </div>

            {selectedSite && (
              <div className={styles.formGroup}>
                <label className={styles.label}>Site Enrollment Status</label>
                <div className={styles.statusInfo}>
                  <div>
                    <p className={styles.statusTitle}>
                      {selectedSite.code} - {selectedSite.name}
                    </p>
                    <p className={styles.statusDetail}>
                      {selectedSite.enrolled} of {selectedSite.maxEnrollment}{' '}
                      subjects enrolled
                    </p>
                    <div className={styles.progressBar}>
                      <div
                        className={styles.progressFill}
                        style={{ width: `${selectedSite.progress}%` }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </form>
        </div>

        <div className={styles.drawerFooter}>
          {mode === 'view' ? (
            <button className={styles.cancelButton} onClick={onClose}>
              Close
            </button>
          ) : mode === 'edit' ? (
            <>
              <button className={styles.cancelButton} onClick={onClose}>
                Cancel
              </button>
              <button
                className={styles.primaryButton}
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Saving...' : 'Save Changes'}
              </button>
            </>
          ) : (
            <>
              <button className={styles.cancelButton} onClick={onClose}>
                Cancel
              </button>
              <button
                className={styles.enrollButton}
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Creating...' : 'Enroll New Subject'}
              </button>
              <button
                className={styles.primaryButton}
                onClick={handleCreateAndCapture}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Creating...' : 'Create & Start Capture'}
              </button>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default SubjectDrawer;
